'use client'
import { useState, useEffect } from 'react'
import { createMd } from "@/lib/util/markdownToHtml"
import ScoreCard from '@modules/layout/components/score-card';
import ProductCard from '@modules/layout/components/product-card';

// 组件映射
const CUSTOM_COMPONENTS = {
  'product-param': ProductCard,
  'score-card': ScoreCard,
  // 在这里添加更多组件
};

function PreviewWysiwyg({ product, data = "" }) {
  const [width, setWidth] = useState(0)  
  const md = createMd(width);
  
  const renderCustomComponent = (tagName, attributes) => {
    const Component = CUSTOM_COMPONENTS[tagName];
    if (!Component) {
      console.warn(`Unknown component: ${tagName}`);
      return null;
    }    
    return <Component key={Math.random()} {...attributes} product={product} />;
  };

  const parseAttributes = (attributeString) => {
    const attrs = {};
    const matches = attributeString.match(/(\w+)="([^"]*)"/g);
    if (matches) {
      matches.forEach(match => {
        const [key, value] = match.replace(/"/g, '').split('=');
        attrs[key] = value;
      });
    }
    return attrs;
  };

  const renderContent = () => {
    const customComponentRegex = new RegExp(`<(${Object.keys(CUSTOM_COMPONENTS).join('|')})\\s*([^>]*)\\s*/>`, 'g');
    const segments = data.replaceAll("\\n", "\n").split(customComponentRegex);
    const content = segments.map((segment, index) => {
      if (index % 3 === 1) {  // 这是一个组件名        
        const tagName = segment;
        const attributeString = segments[index + 1];
        const attributes = parseAttributes(attributeString);
        return renderCustomComponent(tagName, attributes);
      } else if (index % 3 === 0) {  // 这是普通文本
        const html = md.render(segment)        
        return <div key={index} dangerouslySetInnerHTML={{ __html: html }} />;
      }
      return null;
    }).filter(Boolean);
    return content
  };

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])


  return (
    <div className="preview-wysiwyg">
      {renderContent()}
    </div>
  );
}

export default PreviewWysiwyg;